import { createSelector } from '@reduxjs/toolkit';
import type { TRootState } from 'src/store/store-types';

const costCodes = ({ entities }: TRootState) => entities.costCodes;

export const selectCostCodesItems = createSelector([costCodes], ({ costCodesItems }) =>
  costCodesItems.filter((item) => !item.isCategory),
);

export const selectCostCodesCategories = createSelector([costCodes], ({ costCodesItems }) =>
  costCodesItems.filter((item) => item.isCategory),
);

export const selectCostCodesIsAdding = createSelector([costCodes], ({ isAdding }) => isAdding);

export const selectCostCodesIsFetching = createSelector([costCodes], ({ isFetching }) => isFetching);

export const selectCostCodesIsUpdating = createSelector([costCodes], ({ isUpdating }) => isUpdating);

export const selectCostCodesItemOptions = createSelector([selectCostCodesItems], (items) => {
  return items
    .filter((item) => item.deleted === null)
    .map((item) => ({
      value: item.costCodesId,
      label: `${item.code} - ${item.name}`,
    }));
});

export const selectCostCodesCategoryOptions = createSelector([selectCostCodesCategories], (items) => {
  return items
    .filter((item) => item.deleted === null)
    .map((item) => ({
      value: item.costCodesId,
      label: `${item.code} - ${item.name}`,
    }));
});

export const selectCostCodesIdToCodeMap = createSelector([costCodes], ({ costCodesItems }) => {
  return new Map(costCodesItems.map((item) => [item.costCodesId, item.code]));
});

export const selectCostCodesIdToCodeAndNameMap = createSelector([costCodes], ({ costCodesItems }) => {
  return new Map(costCodesItems.map((item) => [item.costCodesId, `${item.code} - ${item.name}`]));
});

export const selectCostCodesError = createSelector([costCodes], ({ error }) => error);

export const selectCostCodesItemNoNameOptions = createSelector([selectCostCodesItems], (items) => {
  return items
    .filter((item) => item.deleted === null)
    .map((item) => ({
      value: item.costCodesId,
      label: `${item.code} - ${item.name}`,
    }));
});

export const selectCostCodesCodeToIdMap = createSelector([costCodes], ({ costCodesItems }) => {
  return new Map(costCodesItems.map((item) => [item.code, item.costCodesId]));
});

export const selectCostCodesCodeAndNameToIdMap = createSelector([costCodes], ({ costCodesItems }) => {
  return new Map(costCodesItems.map((item) => [`${item.code} - ${item.name}`, item.costCodesId]));
});
